export default __webpack_public_path__ + "static/media/OCGO-slider1.c252755c.jpg";